/* eslint-disable @typescript-eslint/no-explicit-any */
import { CaretDown, Faders, SignOut } from '@phosphor-icons/react'
import { forwardRef, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { motion } from 'framer-motion'
import { useOutsideClick } from '@/core/hooks/useOutSideClick'
import { Link } from 'react-router-dom'
import React from 'react'
import { useUserStore } from '@/store/auth/store'
import { useTranslation } from 'react-i18next'

const UserDropdown = forwardRef(
  () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState<boolean>(false)
    const user = useUserStore((state) => state.user)
    const avatar = user?.avatar
    const logout = useUserStore((state) => state.logout)
    const refProfileNav = useOutsideClick(() => {
      setOpen(false)
    })
    const openDropdown = (e: any) => {
      e.preventDefault()
      setOpen((prev) => !prev)
    }

    const handleLogout = (e: any) => {
      e.preventDefault();
      logout();
    }

    const username = (user?.username !== '') ? user?.username : `${user?.firstName} `

    return (
      <>
        <div className="user-dropdown" ref={refProfileNav}>
          <div className="user-dropdown__button" onClick={openDropdown}>
            <div className="user-dropdown__button-avatar">
              {
                avatar && <img src={avatar.includes('https') ? avatar : `${import.meta.env.VITE_CDN_URL}${avatar}`} width={30} height={30} alt="avt" />
              }
            </div>
            <div className="user-dropdown__button-username">
              <p className="txt-button-m">{username}</p>
              <CaretDown
                size={14}
                color="#000"
                weight="regular"
                className={open ? 'icon active' : 'icon'}
              />
            </div>
          </div>
          <AnimatePresence>
            {open ? (
              <motion.div
                initial={{ opacity: 0, translateY: -20 }}
                animate={{ opacity: 1, translateY: 0 }}
                exit={{ opacity: 0, translateY: 0 }}
                transition={{
                  type: 'spring',
                  stiffness: 400,
                  damping: 30,
                  mass: 1,
                  delay: 0,
                }}
                className="user-dropdown__menu"
              >
                <Link
                  to="/user-preferences"
                  className="user-dropdown__menu-item txt-button-m"
                >
                  <span>
                    <Faders
                      size={22}
                      color="currentColor"
                      weight={'light'}
                      mirrored={false}
                    />
                  </span>
                  {t("sidebar.user_preferences")}
                </Link>
                <a
                  className="user-dropdown__menu-item txt-button-m"
                  onClick={handleLogout}
                >
                  <span>
                    <SignOut size={22} color="currentColor" weight="light" />
                  </span>
                  {t("sidebar.logout")}
                </a>
              </motion.div>
            ) : (
              <></>
            )}
          </AnimatePresence>
        </div>
      </>
    )
  }
)
UserDropdown.displayName = 'UserDropdown'

export default UserDropdown
